
import '@angular/localize/init';
import 'zone.js';

(window as any).global = window;
(window as any).global = window;
// (window as any).process = {
//     env: { DEBUG: undefined },
//   };
